import { render, staticRenderFns } from "./DiagnosisPares.vue?vue&type=template&id=42fc429c&"
import script from "./DiagnosisPares.vue?vue&type=script&lang=js&"
export * from "./DiagnosisPares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports